import PropTypes from 'prop-types';

import { formStyle } from './styles.module.scss';

export const Form = ({ children }) => {
  return <form className={formStyle}>{children}</form>;
};

Form.propTypes = {
  children: PropTypes.node.isRequired
};
